﻿export class currency_info {
    iso_currency_code: string = "";
    currency: string = "";
    currency_mask: string = "";
}